// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  archive: true,
  enableImageTrust: true,
  enableWorkflow: false,
  isDjangoAuth: false,
  isCognitoAuth: false,

  //Dev Workflow API Gateway 
  workflowJBPMServerUrl : "https://docuedge-998033653.us-east-2.elb.amazonaws.com:8090/rest/server",

  //Demo Workflow API Gateway 
  //workflowJBPMServerUrl : "https://mvdiop01rc.execute-api.us-east-2.amazonaws.com/dev/rest/server",

  //MCRTX Environment
  // apiUrl: 'https://docuedgevault-api.mcrrfr.deloitte.com',
  cognitoSignInUrl: 'https://docuedge-vault.auth.us-east-1.amazoncognito.com/login?client_id=1hfn1fnpfv8h73h52idr3sb4du&response_type=token&scope=aws.cognito.signin.user.admin&redirect_uri=https://docuedge-vault.mcrrfr.deloitte.com/login',
  cognitoSignOutUrl: 'https://docuedge-vault.auth.us-east-1.amazoncognito.com/logout?client_id=1hfn1fnpfv8h73h52idr3sb4du&response_type=token&redirect_uri=https://docuedge-vault.mcrrfr.deloitte.com/login',

  //AWS Demo Environment
  //apiUrl: 'https://il4p364yh4.execute-api.us-east-2.amazonaws.com/dev'

  //Paypal Endpoint
  //apiUrl:'https://paypalonboarding.docuedgeapidev.deloitte.com'

  //AWS Dev Environment
  apiUrl: 'https://km0gvq0iu0.execute-api.us-east-2.amazonaws.com/dev'

  //FL-DocuEdge Endpoint
  //apiUrl:'https://dev-docuedge.fxedw.com'
  //apiUrl:'https://internal-fx-edw-dev-docuedge-alb-271820985.us-east-1.elb.amazonaws.com'

  //Azure Environment
  //apiUrl: 'https://docuedge.azurewebsites.net'

  //StateOfIndiana
  //apiUrl: 'https://bc90jf0g7a.execute-api.us-east-2.amazonaws.com/dev'

  //GCP Dev Environment
  //apiUrl: 'https://mw0f6agaae.execute-api.us-east-2.amazonaws.com/dev'
  //apiUrl: 'http://3.133.112.4:8000'

  //apiUrl: 'https://prxmejqimd.execute-api.us-east-2.amazonaws.com/dev' 
  //apiUrl: 'http://localhost:8000',

  //apiUrl: 'http://3.21.37.195:8000'
  //apiUrl: 'http://dcidocuedge.eastus2.azurecontainer.io:8000'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
